import React, { useState } from "react";
import { ClosedEyeIcon, OpenEyeIcon } from "../../../../assets/svg/password-modal-icons";
import { WEBSITE_URL } from "../../../../assets/appConstants";
import { checkPasswordPolicy, getPasswordStrength } from "../registrationWizardValidation";
import RegistrationWizardState from "../registrationWizardState";
import {
  needsPasswordOnSecurityStep,
  needsTermsOnSecurityStep,
} from "../registrationWizardSteps";

const STRENGTH_LABELS = {
  weak: "Weak",
  mid: "Medium",
  strong: "Strong",
};

const TERMS_URL = `${WEBSITE_URL}/clinician-terms-of-use`;

const AccountSecurityStep = () => {
  const [showPassword, setShowPassword] = useState(false);
  const account = RegistrationWizardState.getAccount();
  const d = RegistrationWizardState.getStepData();
  const showPasswordField = needsPasswordOnSecurityStep(account);
  const showTermsField = needsTermsOnSecurityStep(account);
  const policy = checkPasswordPolicy(d.password.value);
  const strength = getPasswordStrength(d.password.value);

  const renderPolicyItem = (met, label) => (
    <li className={met ? "met" : ""}>
      <span className="clinician-onboard-policy-check">{met ? "✓" : ""}</span>
      {label}
    </li>
  );

  return (
    <div>
      <h2 className="clinician-onboard-title">
        {showPasswordField && showTermsField
          ? "Account security"
          : showPasswordField
          ? "Choose password"
          : "Terms & Conditions"}
      </h2>
      <p className="clinician-onboard-subtitle">
        {showPasswordField && showTermsField
          ? "Set your password and accept the terms to continue."
          : showPasswordField
          ? "Create a strong password to protect your account."
          : "Please review and accept the terms to continue."}
      </p>

      {showPasswordField && (
        <div className="clinician-onboard-field">
          <label>Password</label>
          <div className="clinician-onboard-password-wrap">
            <input
              className="clinician-onboard-input"
              type={showPassword ? "text" : "password"}
              value={d.password.value}
              onChange={(e) => RegistrationWizardState.updateField("password", e.target.value)}
              placeholder="Example: 123Apple23"
              autoComplete="new-password"
            />
            <button
              type="button"
              className="clinician-onboard-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label="Show password"
            >
              {showPassword ? <OpenEyeIcon /> : <ClosedEyeIcon />}
            </button>
          </div>
          {strength && (
            <div className={`clinician-onboard-password-strength ${strength}`}>
              <div className="clinician-onboard-password-strength__bar">
                <span />
                <span />
                <span />
              </div>
              <span className="clinician-onboard-password-strength__label">
                {STRENGTH_LABELS[strength]}
              </span>
            </div>
          )}
          <ul className="clinician-onboard-policy-list">
            {renderPolicyItem(policy.minLength, "8+ characters")}
            {renderPolicyItem(policy.hasUpper, "1 uppercase")}
            {renderPolicyItem(policy.hasLower, "1 lowercase")}
            {renderPolicyItem(policy.hasDigit, "1 digit")}
          </ul>
        </div>
      )}

      {showTermsField && (
        <div className="clinician-onboard-terms">
          <input
            type="checkbox"
            id="clinicianAcceptTerms"
            className="clinician-onboard-checkbox"
            checked={d.acceptTerms.value}
            onChange={(e) => RegistrationWizardState.updateField("acceptTerms", e.target.checked)}
          />
          <label htmlFor="clinicianAcceptTerms">
            I agree to Wizecare&apos;s{" "}
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
              Terms &amp; Conditions
            </a>
          </label>
        </div>
      )}
    </div>
  );
};

export default AccountSecurityStep;
